import React from "react";

const HashConcept = props => {
  const mathStyle = { fontFamily: "Georgia", fontSize: "8pt", width: "100%" };

  return (
    <div>
      <p className="step-p">
        A hashing function takes data as input, and returns a unique hash.
      </p>

      <p className="step-p" style={mathStyle}>
        f ( data ) = hash
      </p>

      <p className="step-p">
        Since the hash is a "digital fingerprint" of the entire block, the data
        is the combination of index, timestamp, previous hash, block data, and
        nonce.
      </p>

      <p className="step-p" style={mathStyle}>
        f ( index + previous hash + timestamp + data + nonce ) = hash
      </p>

      <p className="step-p">
        Replace the values for our genesis block, we get:
      </p>

      <p className="step-p" style={mathStyle}>
        f ( 0 + "0" + 1508270000000 + "Welcome to Blockchain Demo 2.0!" + 604 ) =
        000dc75a315c77a1f9c98fb6247d03dd18ac52632d7dc6a9920261d8109b37cf
      </p>
    </div>
  );
};

export default HashConcept;



// WEBPACK FOOTER //
// ./src/steps/hash-3/hash-concept.js